const storageKey = (loopId: number) => `planner.lastScenarioId.${loopId}`;

export const getLastVisitedScenarioId = (loopId: number): number | null => {
  try {
    const raw = localStorage.getItem(storageKey(loopId));
    if (!raw) return null;
    const parsed = Number(raw);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
};

export const setLastVisitedScenarioId = (loopId: number, scenarioId: number): void => {
  try {
    localStorage.setItem(storageKey(loopId), String(scenarioId));
  } catch {
    /* localStorage unavailable (quota, privacy mode) — ignore */
  }
};

export const clearLastVisitedScenarioId = (loopId: number): void => {
  try {
    localStorage.removeItem(storageKey(loopId));
  } catch {
    /* localStorage unavailable — ignore */
  }
};
